// Piezas chicas compartidas por el login: esquinas, campo con etiqueta e ícono
// de huella. Extraídas de LoginPage.tsx sin cambios de lógica.

export function Fingerprint({
  color = '#66e0ff',
  size = 26,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 11c0-1.66 1.34-3 3-3s3 1.34 3 3v1c0 3.31-2.69 6-6 6" />
      <path d="M12 11c0-1.66-1.34-3-3-3s-3 1.34-3 3v1c0 1.61.6 3.09 1.6 4.22" />
      <path d="M2 12c0-5.52 4.48-10 10-10s10 4.48 10 10" />
      <path d="M12 7v1" />
      <path d="M15 22c-1-1.5-1.5-3.5-1.5-6" />
    </svg>
  );
}

export function Tick({ pos }: { pos: 'tl' | 'tr' | 'bl' | 'br' }) {
  const isTop = pos.includes('t');
  const isLeft = pos.includes('l');
  return (
    <>
      <span
        className="dd-tick"
        style={{
          [isTop ? 'top' : 'bottom']: -1,
          [isLeft ? 'left' : 'right']: -1,
          width: 10,
          height: 1,
        }}
      />
      <span
        className="dd-tick"
        style={{
          [isTop ? 'top' : 'bottom']: -1,
          [isLeft ? 'left' : 'right']: -1,
          width: 1,
          height: 10,
        }}
      />
    </>
  );
}

export function Field({
  label,
  hint,
  error,
  trailing,
  children,
}: {
  label: string;
  hint?: React.ReactNode;
  error?: string;
  /** Control a la derecha del input (ej. toggle de ver contraseña). Si se
   *  pasa, reemplaza al punto decorativo. */
  trailing?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
        }}
      >
        <label
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: 10,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.55)',
            textTransform: 'uppercase',
            letterSpacing: '0.14em',
          }}
        >
          {label}
        </label>
        {hint}
      </div>
      <div className="dd-input-wrap">
        {children}
        {trailing ?? <span className="dd-input-dot" aria-hidden="true" />}
      </div>
      {error && (
        <span
          role="alert"
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: 10.5,
            color: '#ff8e8e',
            letterSpacing: '0.04em',
          }}
        >
          {error}
        </span>
      )}
    </div>
  );
}
